import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "desktop-header ion-padding-horizontal" }
const _hoisted_2 = { class: "group-button" }
const _hoisted_3 = {
  key: 0,
  class: "button__btn-notice__badge"
}

import {
    IonIcon,
    IonButton
} from "@ionic/vue";
import SearchForm from "@/modules/General/components/SearchForm.vue";
import router from "@/router";
import {RouteNamesEnum} from "@/const/routes";
import { RegistrationProgress } from "@/gql/graphql";
import { computed } from "vue";
import { useUserStore } from "../store/userStore";
import { hasUnreadEvents } from "@/helpers/setUnreadEvents";
import { disableListeners } from "@/helpers/cordova-plugin-purchase";
import { isMobile } from "@/helpers/isMobile";


export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopHeader',
  props: {
    isSearchAvailable: { type: Boolean }
  },
  setup(__props: any) {

const user = computed(() => useUserStore()?.user);

const isActiveSubscriber = computed(() => user.value?.team?.is_active_subscriber || (user.value?.is_impersonated && (user.value?.registration_progress === RegistrationProgress.Completed || user.value?.registration_progress === RegistrationProgress.Admin)));
const onLogout = () => {
  router.push({ name: RouteNamesEnum.Logout });
  if(isMobile.value) {
    disableListeners();
  }
}


const navigateNotification = () => {
  router.push({name: RouteNamesEnum.Notifications});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.isSearchAvailable)
        ? (_openBlock(), _createBlock(SearchForm, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isSearchAvailable)
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 0,
            class: "button",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                src: "assets/icon/filter.svg"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (isActiveSubscriber.value)
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 1,
            class: "button button__btn-notice",
            fill: "clear",
            onClick: navigateNotification
          }, {
            default: _withCtx(() => [
              (_unref(hasUnreadEvents))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                : _createCommentVNode("", true),
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                src: "assets/icon/notice.svg"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonButton), {
        class: "user-profile__btn-notice",
        fill: "clear",
        onClick: onLogout
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            slot: "icon-only",
            src: "assets/icon/log-out.svg"
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})